export function sidebarToggler() {
    document.querySelector("body").classList.toggle('toggle-sidebar');
}